import { Typography } from 'antd'

const { Title } = Typography

export default function FAQs() {
  return <>
    <Title level={2}>Frequently Asked Questions</Title>
    
  </>
}